import { useNavigate } from "@tanstack/react-router";
import { AlertCircle } from "lucide-react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { EmptyState } from "@/shared/components/EmptyState";
import { Spinner } from "@/shared/ui/spinner";

import { useSplit } from "../api/use-split";
import { SplitDetail } from "../components/SplitDetail";

interface SplitDetailPageProps {
  saleOrderId: string;
}

export function SplitDetailPage({ saleOrderId }: SplitDetailPageProps): JSX.Element {
  const { t } = useTranslation("orders");
  const navigate = useNavigate();

  const { data: split, isLoading, isError } = useSplit(saleOrderId);

  function handleBack(): void {
    void navigate({ to: "/split-orders" });
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-16" data-testid="split-detail-loading">
        <Spinner size="lg" label={t("loading_orders")} />
      </div>
    );
  }

  if (isError || !split) {
    return (
      <EmptyState
        icon={<AlertCircle className="h-6 w-6" />}
        title={t("empty_order_not_found")}
        body={t("empty_order_not_found_desc")}
      />
    );
  }

  return <SplitDetail split={split} onBack={handleBack} />;
}
